import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { Box, Container, Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Order, Mastercode } from 'types/schema-generated-types';
import { ORDER_DATE_FORMAT } from '../../utils/constants';

export type Props = {
  order: Order;
  mastercodes: Mastercode[];
  isActivateCode?: boolean;
};

const MastercodeModalDetails = ({ order, mastercodes, isActivateCode = false }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('Order');

  const orderDate = format(new Date(order.dateOrdered), ORDER_DATE_FORMAT);

  return (
    <Container maxWidth="sm">
      <Grid item xs={12} sm={12}>
        <Typography variant="subtitle1" className={classes.title}>
          {t(isActivateCode ? 'activateCodes' : 'transferCodes')}
        </Typography>
        <Typography className={classes.muted}>{t('orderDate', { orderDate })}</Typography>
        {mastercodes.map((mastercode, idx) => (
          <Box key={`mastercode-info-${mastercode.id}`}>
            <Typography className={classes.muted}>
              {t('mastercode', { code: mastercode.code })}
            </Typography>
            {mastercode.parentMastercode && (
              <Typography className={classes.muted}>
                {t('parentMastercode', { code: mastercode.parentMastercode?.code })}
              </Typography>
            )}
            {idx < mastercodes.length - 1 && <Divider className={classes.divider} />}
          </Box>
        ))}
      </Grid>
    </Container>
  );
};

export default MastercodeModalDetails;

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    fontWeight: 500
  },
  muted: {
    color: theme.palette.grey[700]
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));
